import { showAlertCallout } from "@/shared/alerts";
import { useConfirmPopoverStore } from "@/shared/stores";
import { ERROR_DISPLAY_TYPES } from "@/shared/utils/errors/error.types";
import {
  getTranslationKeyAndDisplayTypes,
  hasErrorDisplayType,
} from "@/shared/utils/errors/get-http-error-type";
import { showHttpErrorAlertCallout } from "@/shared/utils/show-http-error-alert-callout";
import {
  deleteRoleById,
  getGetRoleListPaginatedQueryKey,
} from "@/spz-api/roles/roles";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
type DeleteRoleMutationVariables = {
  id: string;
  headers?: Record<string, string>;
};
export const selectDeleteRolePopover = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { openPopover, closePopover } = useConfirmPopoverStore();

  const deleteRoleByIdMutation = useMutation<
    void,
    unknown,
    DeleteRoleMutationVariables
  >({
    mutationFn: async (variables) => {
      const { id, headers } = variables;
      await deleteRoleById(id, {
        headers: { ...headers, "Content-Type": "application/json" },
      });
    },
    onSuccess: () => {
      showAlertCallout({
        type: "success",
        title: t("delete_role_success"),
      });

      queryClient.invalidateQueries({
        queryKey: getGetRoleListPaginatedQueryKey({}),
      });
      closePopover();
    },
    onError: (error) => {
      const { translationKey, displayTypes } =
        getTranslationKeyAndDisplayTypes(error);
      const message = t(translationKey);

      if (hasErrorDisplayType(displayTypes, ERROR_DISPLAY_TYPES.TOAST)) {
        showHttpErrorAlertCallout({
          error: message,
        });
      }
    },
  });
  const handleDeleteClick = ({
    roleId,
    anchorElement,
    updatedAt,
  }: {
    roleId: string;
    anchorElement: HTMLElement;
    updatedAt?: Date;
  }) => {
    openPopover({
      description: t("delete_role_description"),
      anchorElement,
      onConfirm: () => {
        deleteRoleByIdMutation.mutate({
          id: roleId,
          headers: updatedAt
            ? { "if-match": updatedAt.toISOString() }
            : undefined,
        });
      },
    });
  };

  return {
    open: handleDeleteClick,
  };
};
